class LiveChartAPIManager {
    constructor() {
        
    }

    static create() {
        if (!LiveChartAPIManager.instance) {
            LiveChartAPIManager.instance = new LiveChartAPIManager();
        }
        return LiveChartAPIManager.instance;
    }

    async fetchTickerEvents(ticker) {
        if (!ticker) return []
        try {
            const baseURLAPI = 'https://api.palosverdestech.com/tickers/details/events';
            const fullURL = `${baseURLAPI}/${ticker}`

            const response = await fetch(fullURL);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const jsonData = await response.json();
            
            if (jsonData && jsonData.items && Array.isArray(jsonData.items)) {
                return  jsonData.items;
            }
            return []
        } catch (error) {
            console.error(`Error fetchTickerDetails: ${error.message}`);
            return []
        }
    }

    async fetchLiveChartData(ticker, interval = '1d', secondarySeriesType = 'volume') {
        if (!ticker) return null
        try {
            const baseURLAPI = 'https://api.palosverdestech.com/tickers/details/livechart-v2/';
            let fullURL = `${baseURLAPI}/${ticker}/${interval}`
            if (secondarySeriesType === 'dividend') fullURL += '?div=1'
            if (secondarySeriesType === 'sip') fullURL += '?si=1'

            const response = await fetch(fullURL);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const jsonData = await response.json();
            
            return  jsonData || null
        } catch (error) {
            console.error(`Error fetchTickerDetails: ${error.message}`);
            return null
        }
    }

}

window.LiveChartAPIManager = LiveChartAPIManager;